/** Which modifier key the command palette label should name on this machine.
 *  The hotkey itself (useCommandPaletteHotkey) accepts both ⌘ and Ctrl; only
 *  the label changes. */

type NavigatorWithUAData = Navigator & { userAgentData?: { platform?: string } }

/** True on Apple machines (macOS, iPadOS, iOS), where the key is ⌘.
 *  Anything we can't read counts as not-Mac. */
export function isMacLike(): boolean {
  try {
    const nav = navigator as NavigatorWithUAData
    const platform = nav.userAgentData?.platform ?? nav.platform ?? ''
    return /mac|iphone|ipad|ipod/i.test(platform)
  } catch {
    return false
  }
}

/** The shortcut shown on the Jump button: "⌘K" on a Mac, "Ctrl K" elsewhere. */
export function commandPaletteHint(): string {
  return isMacLike() ? '⌘K' : 'Ctrl K'
}
